import $ from 'jquery';

export default function resendEmailModule() {
  const resendEmailElement = $('#resend-mail-button');
  if (resendEmailElement.length) {
    return import(/* webpackChunkName: "resend-email" */ '../resendEmail')
      .then(({ default: ResendEmail }) => {
        const resendEmail = new ResendEmail();
        return resendEmail;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
